

const calculateBarWidth = (numberOfBars,inputLow,inputHigh,outputHigh, outputLow) => {

    let result = ((numberOfBars - inputLow) / (inputHigh - inputLow)) * (outputHigh - outputLow) + outputLow;
    return result;
}
export const getNumberDependingOnBars = (data) =>
{
    const numberOfElements = data.items.length;
    let lowBorder = 100
    let mediumBorder = 150
    let highBorder = 500

    let lowBarWidth = 5
    let mediumBarWidth = 10
    let highBarWidth = 20
    let maxBarWidth = 30

    if(numberOfElements > lowBorder && numberOfElements < mediumBorder)
    {
        return Math.floor(calculateBarWidth(data.items.length, lowBorder, mediumBorder, highBarWidth, mediumBarWidth))       
    }
    if(numberOfElements < mediumBorder)
    {
        return Math.floor(calculateBarWidth(data.items.length, 1, mediumBorder, mediumBarWidth, lowBarWidth))      
    }
    return Math.floor(calculateBarWidth(data.items.length, mediumBorder, highBorder, maxBarWidth, mediumBarWidth))  
   
        
}